import { partition } from 'lodash'

import BaseModel from '../common/base-model'
// import {
//   CRITERIA_CONFIG as arrivalAndDepartureCriteriaConfig,
//   CRITERIA_CONFIG_FLAT as arrivalAndDepartureCriteriaConfigFlat,
// } from './arrival-and-departure-criteria-config'
// import {
//   CRITERIA_CONFIG as onsiteCriteriaConfig,
//   CRITERIA_CONFIG_FLAT as onsiteCriteriaConfigFlat,
// } from './onsite-criteria-config'
// import {
//   CRITERIA_CONFIG as shuttleCriteriaConfig,
//   CRITERIA_CONFIG_FLAT as shuttleCriteriaConfigFlat,
// } from './shuttle-criteria-config'

export class TransportationPoint extends BaseModel {
  id
  address
  enabledForArrival = false
  enabledForDeparture = false
  enabledForOnsite = false
  enabledForShuttle = false
  latitude
  longitude
  name
  description
  locationId
  createdAt
  updatedAt
  arrivalCriteria
  departureCriteria
  onsiteCriteria
  shuttleCriteria
  transportationPointImages = []

  static TB_KINDS_DEFINITIONS = Object.freeze({
    arrival: {
      title: 'Arrival',
      icon: 'mi-outlined mi-flight-land',
      enabled: 'enabledForArrival',
      criteria: 'arrivalCriteria',
      // criteriaConfig: arrivalAndDepartureCriteriaConfig,
      // criteriaConfigFlat: arrivalAndDepartureCriteriaConfigFlat,
    },
    departure: {
      title: 'Departure',
      icon: 'mi-outlined mi-flight-takeoff',
      enabled: 'enabledForDeparture',
      criteria: 'departureCriteria',
      // criteriaConfig: arrivalAndDepartureCriteriaConfig,
      // criteriaConfigFlat: arrivalAndDepartureCriteriaConfigFlat,
    },
    onsite: {
      title: 'On-site',
      icon: 'mi-outlined mi-directions-car',
      enabled: 'enabledForOnsite',
      criteria: 'onsiteCriteria',
      // criteriaConfig: onsiteCriteriaConfig,
      // criteriaConfigFlat: onsiteCriteriaConfigFlat,
    },
    shuttle: {
      title: 'Shuttle',
      icon: 'mi-outlined mi-directions-bus',
      enabled: 'enabledForShuttle',
      criteria: 'shuttleCriteria',
      // criteriaConfig: shuttleCriteriaConfig,
      // criteriaConfigFlat: shuttleCriteriaConfigFlat,
    },
  })

  get KINDS() {
    return ['arrival', 'departure', 'onsite', 'shuttle']
  }

  constructor(obj) {
    super()
    this.initialize(obj)
  }

  clearOslsByTbKind(kind) {
    const [byKind, other] = (this.transportationPointOsls = partition(
      this.transportationPointOsls,
      osl => osl.tbKind === kind,
    ))

    this.transportationPointOsls = [...other, ...byKind.map(osl => ({ ...osl, _destroy: true }))]
  }

  getOslsByKind(kind) {
    return this.transportationPointOsls.filter(osl => osl.tbKind === kind && !osl._destroy)
  }

  getOslsToRemove() {
    return this.transportationPointOsls.filter(osl => osl._destroy)
  }

  serialize() {
    const json = { ...this }

    Object.values(TransportationPoint.TB_KINDS_DEFINITIONS).forEach(value => {
      if (!this[value.enabled]) {
        json[value.leadTime] = null
        json[value.loadTime] = null
        if (value.criteria) {
          json[value.criteria] = {}
        }
      }
    })

    return json
  }
}
